<template>
  <div class="flex flex-col gap-y-3 overflow-y-auto pr-2">
    <el-form
      v-if="state.model.status == 1"
      :model="state.check"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
    >
      <el-form-item label="付款说明">
        <el-input v-model="state.check.remark" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="附件" class="!flex flex-col">
        <template #label>
          <div class="flex items-center">
            <text>附件</text>
            <el-upload
              :show-file-list="false"
              :auto-upload="false"
              multiple
              :on-change="onFileChange"
            >
              <el-button type="primary" size="small" link icon="plus">
                上传
              </el-button>
            </el-upload>
          </div>
        </template>
        <div class="!w-full flex flex-wrap gap-x-5 gap-y-2">
          <li
            v-for="(file, index) in state.check.files"
            class="grid items-center hover:underline cursor-pointer text-green-700"
            style="grid-template-columns: 1fr auto"
            @click="$openFile(file.file_url)"
          >
            <text>{{ file.origin_filename }}</text>
            <el-icon
              color="#f00"
              @click.stop="state.check.files?.splice(index, 1)"
              class="hover:scale-110 text-red-400 cursor-pointer ml-2"
            >
              <Close />
            </el-icon>
          </li>
        </div>
      </el-form-item>
      <ul class="text-center">
        <el-button type="primary" @click="onSubmit">确定支付</el-button>
      </ul>
    </el-form>
    <ul class="flex gap-x-3 items-center">
      <strong>{{ state.model?.number }}</strong>
      <text class="text-gray-400 text-xs">无采购付款</text>
      <c_money
        :key="state.model.amount"
        :value="state.model.amount"
        :size="20"
        bold
      />
      <c_status
        arrName="Office_Expense_Apply_Status"
        :value="state.model?.status"
        :key="state.model?.status"
        showBg
      />
    </ul>
    <c_cell title="供应商">
      <template #default>
        <div class="flex gap-x-3">
          <text>{{ state.model?.supplier?.name }}</text>
          <li class="flex gap-x-3 text-xs text-gray-400">
            <text>{{ state.model?.supplier?.number }}</text>
            <text>{{ state.model?.supplier?.contact_name }}</text>
            <c_sex
              :value="
                state.model?.supplier?.contact_title == '先生' ? '男' : '女'
              "
            />
            <text>{{
              $phoneFormat(state.model?.supplier?.contact_phone)
            }}</text>
          </li>
        </div>
      </template>
    </c_cell>
    <ul class="flex gap-x-5">
      <c_cell title="付款方式" :value="state.model?.d_payment_type_name" />
      <c_cell title="收款信息">
        <template #default>
          <div class="flex gap-x-2">
            <text>{{ state.model?.supplier_bank_account?.opening_bank }}</text>
            <text class="text-gray-400">{{
              state.model?.supplier_bank_account?.name
            }}</text>
            <text class="text-gray-400">{{
              state.model?.supplier_bank_account?.account
            }}</text>
          </div>
        </template>
      </c_cell>
    </ul>
    <c_cell title="申请说明" :value="state.model?.intro" />
    <c_cell title="附件">
      <template #default>
        <div
          class="flex flex-wrap gap-x-5 gap-y-2"
          v-if="state.model?.attachment?.length > 0"
        >
          <text
            v-for="file in state.model?.attachment"
            :key="item"
            class="hover:underline cursor-pointer text-green-700"
            @click="$openFile(file.file_url)"
          >
            {{ file.filename }}
          </text>
        </div>
        <text v-else>-</text>
      </template>
    </c_cell>
    <template v-if="state.model.status == 2">
      <c_cell title="付款说明" :value="state.model.transaction_remark" />
      <c_cell title="付款附件">
        <template #default>
          <div
            class="flex flex-wrap gap-x-5 gap-y-2"
            v-if="state.model?.transaction_attachment?.length > 0"
          >
            <text
              v-for="file in state.model?.transaction_attachment"
              :key="item"
              class="hover:underline cursor-pointer text-green-700"
              @click="$openFile(file.file_url)"
            >
              {{ file.filename }}
            </text>
          </div>
          <text v-else>-</text>
        </template>
      </c_cell>
      <div class="flex items-center text-gray-400 text-xs gap-x-2">
        <text class="text-sm text-gray-600">
          {{ state.model?.transaction_admin_name }}
        </text>
        <text>{{ state.model?.transaction_department_name }}</text>
        <text class="ml-1">{{ state.model?.transaction_time }} 付款</text>
      </div>
    </template>
    <strong>审核进度</strong>
    <el-steps :active="10" align-center>
      <el-step
        v-for="item in state.flowApproveStepList"
        :key="item"
        :title="item.step_name"
        :description="state.model.create_time"
      >
        <template #description>
          <div class="flex flex-col items-center">
            <template v-if="item.status">
              <ul class="flex gap-x-1">
                <c_status
                  arrName="Common_Check_Status"
                  :value="item.status"
                  showBg
                />
                <text>{{ item.approve_admin_name }}</text>
                <text>{{ item.approve_department_name }}</text>
              </ul>
              <text>{{ item.approve_time }}</text>
            </template>
            <c_status
              v-else
              arrName="Common_Check_Status"
              :value="item.status"
              showBg
            />
          </div>
        </template>
      </el-step>
      <el-step
        v-if="state.model?.status == 2"
        title="付款"
        :description="state.model?.transaction_time"
      >
        <template #description>
          <div class="flex flex-col items-center">
            <ul class="flex gap-x-1">
              <c_status
                arrName="Office_Expense_Apply_Status"
                :value="state.model?.status"
                :key="state.model?.status"
              />
              <text>{{ state.model?.transaction_admin_name }}</text>
              <text class="text-gray-400">{{
                state.model?.transaction_department_name
              }}</text>
            </ul>
            <text>{{ state.model?.transaction_time }}</text>
          </div>
        </template>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  supplierpaymentapply_search,
  supplierpaymentapply_pay,
} from "@/http/fukuanshenpi";
import { ElMessage, ElMessageBox } from "element-plus";
import { attachment_upload } from "@/http/attachment";
import { post_response } from "@/utils/funcs";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
      list_data: [],
      check: {
        files: [],
      },
    });
    onMounted(() => {
      if (props.id) {
        supplierpaymentapply_search(props.id).then((res) => {
          if (res.status == 200) {
            const { info, flowApproveStepList } = res.data?.data || {};
            state.model = info;
            state.flowApproveStepList = flowApproveStepList;
          }
        });
      }
    });

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          state.check.files = [...state.check.files, ...res.data.data];
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          ElMessageBox.confirm(
            `您确定<strong style="color: #080">支付</strong>吗？`,
            "付款",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              dangerouslyUseHTMLString: true,
              cancelButtonClass: "is-plain",
            },
          ).then(() => {
            supplierpaymentapply_pay({
              id: props.id,
              transaction_remark: state.check.remark,
              transaction_attachment: JSON.stringify(
                state.check?.files?.map((m) => m.id),
              ),
            }).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          });
        }
      });
    };
    return { state, formDom, onFileChange, onSubmit };
  },
};
</script>
<style scoped></style>
